import { render } from "./AccountTypeShow.vue?vue&type=template&id=0b1491ec&scoped=true"
import script from "./AccountTypeShow.vue?vue&type=script&lang=js"
export * from "./AccountTypeShow.vue?vue&type=script&lang=js"

import "./AccountTypeShow.vue?vue&type=style&index=0&id=0b1491ec&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1491ec"]])

export default __exports__